export default "__VITE_ASSET__7e76523c__"